export default "__VITE_ASSET__61f4509d__"